<footer class="footer">
    <div class="footer wrapper">
      <div class="footer logo">
        <app-logo></app-logo>
      </div>
      <div class="footer-links">
        <a href="/about">За нас</a>
        <a href="/terms">Услови на користење</a>
        <a href="/privacy">Политика на приватност</a>
      </div>
      <div class="foote socials">
        <!-- Add social media links here -->
      </div>
    </div>
</footer>
